import React from 'react';

// Estilos en línea como fallback
const spinnerStyle = {
  border: '4px solid rgba(131, 69, 148, 0.2)',
  borderTop: '4px solid #834594',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
  display: 'block'
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2rem',
  width: '100%',
  minHeight: '200px'
};

const pageLoadingStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '70vh',
  width: '100%',
  padding: '3rem',
  background: '#ffffff'
};

const messageStyle = {
  marginTop: '1.5rem',
  color: '#834594',
  fontSize: '1rem',
  fontWeight: '600',
  textAlign: 'center'
};

// Spinner único giratorio con color personalizado #834594
const LoadingSpinner = ({ size = 'medium', message = 'Cargando...' }) => {
  const getSizeClass = () => {
    const sizes = {
      small: '32px',
      medium: '48px',
      large: '64px'
    };
    return sizes[size] || sizes.medium;
  };

  const spinnerSize = getSizeClass();

  return (
    <div className="loading-container" style={containerStyle}>
      <div 
        className="loading-spinner-single"
        style={{ 
          ...spinnerStyle,
          width: spinnerSize, 
          height: spinnerSize
        }}
      />
      {message && (
        <div className="loading-message" style={messageStyle}>
          {message}
        </div>
      )}
    </div>
  );
};

// Componente para páginas completas - centrado en toda la vista
const LoadingGrid = ({ message = 'Cargando...' }) => {
  return (
    <div className="page-loading" style={pageLoadingStyle}>
      <LoadingSpinner size="large" message={message} />
    </div>
  );
};

// Overlay para acciones específicas
const LoadingOverlay = ({ isVisible, message = 'Procesando...' }) => {
  if (!isVisible) return null;

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(255, 255, 255, 0.95)',
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  };

  const contentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#ffffff',
    padding: '3rem',
    borderRadius: '12px',
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
    border: '1px solid rgba(131, 69, 148, 0.1)'
  };

  return (
    <div className="loading-overlay" style={overlayStyle}>
      <div className="loading-content" style={contentStyle}>
        <LoadingSpinner size="large" message={message} />
      </div>
    </div>
  );
};

// Agregar keyframes de animación si no existen
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
  if (!document.head.querySelector('[data-loading-styles]')) {
    style.setAttribute('data-loading-styles', 'true');
    document.head.appendChild(style);
  }
}

// Exportar Loading como alias de LoadingGrid para compatibilidad
const Loading = LoadingGrid;

export { LoadingSpinner, LoadingGrid, LoadingOverlay, Loading };
export default Loading;
